import {Component, OnInit, Input, NgZone} from '@angular/core';
import { Observable, Observer } from 'rxjs';

@Component({
  selector: 'app-async-observable',
  templateUrl: './async-observable.component.html',
  styleUrls: ['./async-observable.component.css']
})

export class AsyncObservableComponent implements OnInit {
  public day: number;
  public dayObserver = new Observable<number>((observer: Observer<number>) => {
    setInterval(() => observer.next(this.zone.run( () => this.day++ /*new Date().toString()*/)), 2000);
  });
  constructor(private zone: NgZone) {
    this.day = 0;
  }
  ngOnInit(): void {
  }

}
